import { PreRenderService } from '../../../services/pre-render.service';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {RemaxMarker} from '../../../classes/remax-marker';
import {Listing} from '../../../classes/listing';
import {CurrencyPipe} from '@angular/common';
import {Helper} from '../../../classes/helper';
import {ListingsService} from '../../../services/listings.service';
import LatLngLiteral = google.maps.LatLngLiteral;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnChanges {
  @Input() latLng?: LatLngLiteral;
  @Input() listing?: Listing;
  @Input() isOffice: boolean = false;
  marker: RemaxMarker;
  @Input() customMapOptions = {};
  mapOptions = {
    fullscreenControl: false,
    mapTypeControl: false,
    zoomControl: true,
    streetViewControl: true,
    zoom: 17,
    disableDefaultUI: false,
    draggable: true,
    scrollwheel: true,
    minZoom: 3,
    center: {
      lat: 0,
      lng: 0
    }
  };

  priceOrPricePerSqFt: string;

  mapEnabled = true;

  constructor(private currencyPipe: CurrencyPipe,
              private listingService: ListingsService,
              private preRenderService: PreRenderService) {

    this.mapEnabled = this.preRenderService.isBrowserMode;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let key in this.customMapOptions) {
      this.mapOptions[key] = this.customMapOptions[key];
    }
  }

  @Input()
  set isLDP(isLDP: boolean) {
    if (this.listing) {
      this.listingService.getPriceOrPricePerSqFtString(this.listing).toPromise().then(str => this.priceOrPricePerSqFt = str);
      const price = isLDP ? this.priceOrPricePerSqFt : Helper.formatPrice(this.listing.listPrice);
      this.marker = RemaxMarker.generateListingMarkerFromListing(price, this.listing);
      this.mapOptions.center = {
        lat: this.listing.lat,
        lng: this.listing.lng
      };
    }
    else if (this.latLng) {
      this.mapOptions.center = this.latLng;
      this.marker = RemaxMarker.generatePlainMarker(false, this.isOffice, this.latLng);
    }
  }
}
